module.exports = __webpack_public_path__ + "static/media/box-right-marketing.adbba3fb.png";